// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { BookitupNotification } from '../../../../Types/LogT';
import { RoutingS } from '../../../../Service/RoutingS';
import LinkText from '../../../../Atoms/LinkText';

const TaskOverdue: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { entityLabel, entityType, eventId } = notification;

  const navigateToTask = () => {
    if (entityType === 'events') {
      RoutingS.openInNewTab(`/events/${eventId}/details`);
    } else {
      RoutingS.openInNewTab(`/tasks`);
    }
  };

  return (
    <Text>
      Aufgabe{'  '}
      <LinkText span weight="bolder" onClick={navigateToTask}>
        {` ${entityLabel} `}
      </LinkText>
      {'  '}ist überfällig.
    </Text>
  );
};

export default TaskOverdue;
